(() => {
if (window.__athomePdpScriptLoaded) return;
window.__athomePdpScriptLoaded = true;

class AtHomeProductSection {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-product-form]');
    this.data = this.readProductData();
    this.optionInputs = [...root.querySelectorAll('[data-option-input]')];
    this.variantInput = root.querySelector('[data-variant-id]');
    this.sellingPlanInput = root.querySelector('[data-selling-plan-id]');
    this.quantityInput = root.querySelector('[data-quantity-input]');
    this.quantity = root.querySelector('.ath-pdp__quantity');
    this.quantityControls = [...root.querySelectorAll('[data-quantity-minus], [data-quantity-plus], [data-quantity-input]')];
    this.submit = root.querySelector('[data-add-button]');
    this.submitLabel = root.querySelector('[data-add-label]');
    this.mobileBuyBar = root.querySelector('[data-mobile-buy-bar]');
    this.mobileAddButton = root.querySelector('[data-mobile-add-button]');
    this.mobileAddLabel = root.querySelector('[data-mobile-add-label]');
    this.mobilePrice = root.querySelector('[data-mobile-price]');
    this.price = root.querySelector('[data-price]');
    this.comparePrice = root.querySelector('[data-compare-price]');
    this.oncePrice = root.querySelector('[data-once-price]');
    this.subscriptionPrice = root.querySelector('[data-subscription-price]');
    this.subscriptionLabel = root.querySelector('[data-subscription-label]');
    this.subscriptionDelivery = root.querySelector('[data-subscription-delivery]');
    this.nativeSubscriptionDetails = root.querySelector('[data-native-subscription-details]');
    this.subscriptionSavingsCopies = [...root.querySelectorAll('[data-subscription-savings-copy]')];
    this.sku = root.querySelector('[data-sku]');
    this.gallerySelection = root.querySelector('[data-gallery-selection]');
    this.status = root.querySelector('[data-status]');
    this.firstFoldStatus = root.querySelector('[data-first-fold-status]');
    this.afterpay = root.querySelector('[data-afterpay]');
    this.afterpayAmount = root.querySelector('[data-afterpay-amount]');
    this.afterpayPlacements = [...root.querySelectorAll('square-placement[data-amount]')];
    this.planLabels = [...root.querySelectorAll('[data-plan-card]')];
    this.purchaseFallback = root.querySelector('[data-purchase-fallback]');
    this.rechargeHost = root.querySelector('[data-recharge-host]');
    this.lightbox = root.querySelector('[data-media-lightbox]');
    this.lightboxImage = root.querySelector('[data-media-lightbox-image]');
    this.lightboxClose = root.querySelector('[data-media-lightbox-close]');
    this.handleLightboxKeydown = this.handleLightboxKeydown.bind(this);
    if (this.variantInput) this.variantInput.disabled = false;
    this.bindEvents();
    this.initMobileBuyBar();
    this.updateVariant();
    this.initRechargeDefault();
  }

  readProductData() {
    const node = this.root.querySelector('[data-product-json]');
    if (!node) return { variants: [], moneyFormat: '${{amount}}' };
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('AtHome PDP product data could not be parsed.', error);
      return { variants: [], moneyFormat: '${{amount}}' };
    }
  }

  bindEvents() {
    this.optionInputs.forEach((input) => {
      const preserveViewport = () => {
        this.optionInteractionScrollY = window.scrollY;
      };
      input.nextElementSibling?.addEventListener('pointerdown', preserveViewport, { passive: true });
      input.addEventListener('keydown', preserveViewport);
      input.addEventListener('change', () => {
        const scrollY = Number.isFinite(this.optionInteractionScrollY)
          ? this.optionInteractionScrollY
          : window.scrollY;
        this.optionInteractionScrollY = null;
        this.updateVariant(input);
        this.restoreVariantViewport(scrollY);
      });
    });

    this.planLabels.forEach((label) => {
      const input = label.querySelector('input');
      const preserveViewport = () => {
        this.planInteractionScrollY = window.scrollY;
      };
      label.addEventListener('pointerdown', preserveViewport, { passive: true });
      input?.addEventListener('keydown', preserveViewport);
      label.addEventListener('click', (event) => {
        if (!input || input.disabled || event.detail === 0) return;
        event.preventDefault();
        input.focus({ preventScroll: true });
        if (input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input?.addEventListener('change', () => {
        const scrollY = Number.isFinite(this.planInteractionScrollY)
          ? this.planInteractionScrollY
          : window.scrollY;
        this.planInteractionScrollY = null;
        this.planLabels.forEach((item) => item.classList.remove('is-selected'));
        label.classList.add('is-selected');
        this.updatePrice();
        this.restoreVariantViewport(scrollY);
      });
    });

    this.root.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => this.showMedia(Number(button.dataset.mediaId)));
    });

    this.root.querySelectorAll('.ath-pdp__zoom-trigger').forEach((trigger) => {
      const image = trigger.querySelector('img');
      if (!image) return;
      trigger.addEventListener('click', () => this.openLightbox(image, trigger));
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.openLightbox(image, trigger);
      });
    });

    this.lightboxClose?.addEventListener('click', () => this.closeLightbox());
    this.lightbox?.addEventListener('click', (event) => {
      if (event.target === this.lightbox) this.closeLightbox();
    });

    this.root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (!this.quantityInput) return;
      this.quantityInput.value = this.normalizedQuantity(Number(this.quantityInput.value || 1) - 1);
      this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (!this.quantityInput) return;
      this.quantityInput.value = this.normalizedQuantity(Number(this.quantityInput.value || 1) + 1);
      this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.quantityInput?.addEventListener('change', () => {
      this.quantityInput.value = this.normalizedQuantity(this.quantityInput.value);
      this.updatePrice();
    });
    this.quantityInput?.addEventListener('input', () => this.updatePrice());
    this.form?.addEventListener('submit', () => {
      if (this.quantityInput) this.quantityInput.value = this.normalizedQuantity(this.quantityInput.value);
    }, true);
  }

  normalizedQuantity(value) {
    const min = Math.max(1, Number.parseInt(this.quantityInput?.min || '1', 10) || 1);
    const maxValue = Number.parseInt(this.quantityInput?.max || '', 10);
    const parsed = Number.parseInt(value, 10);
    return Math.min(Number.isFinite(maxValue) ? maxValue : Number.MAX_SAFE_INTEGER, Math.max(min, parsed || min));
  }

  formatDeliveryCadence(value) {
    const cadence = String(value || '').trim();
    if (!cadence) return 'Deliver every 30 days';
    const normalized = cadence.toLowerCase();
    if (normalized === 'monthly') return 'Deliver every 30 days';
    if (normalized === 'weekly') return 'Deliver every week';
    if (normalized === 'quarterly') return 'Deliver every 3 months';
    if (normalized === 'yearly' || normalized === 'annually') return 'Deliver every year';
    if (/^delivery\b/i.test(cadence)) return cadence.replace(/^delivery/i, 'Deliver');
    if (/^deliver\b/i.test(cadence)) return cadence.replace(/^deliver/i, 'Deliver');
    if (/\bevery\b/i.test(cadence)) return `Deliver ${cadence}`;
    return `Deliver every ${cadence}`;
  }

  normalizeRechargeCadenceCopy(widget) {
    widget.querySelectorAll('.rc-selling-plans-single').forEach((label) => {
      const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        node.nodeValue = node.nodeValue
          .replace(/\bDelivery every monthly\b/gi, 'Deliver every 30 days')
          .replace(/\bDeliver every monthly\b/gi, 'Deliver every 30 days')
          .replace(/\bDelivery every\b/gi, 'Deliver every');
      });
    });
  }

  restoreVariantViewport(scrollY) {
    if (!Number.isFinite(scrollY)) return;
    window.cancelAnimationFrame(this.variantViewportFrame);
    this.variantViewportFrame = window.requestAnimationFrame(() => {
      if (!this.root.isConnected || Math.abs(window.scrollY - scrollY) <= 1) return;
      window.scrollTo({ top: scrollY, left: window.scrollX, behavior: 'auto' });
    });
  }

  initRechargeDefault() {
    if (!this.rechargeHost) {
      this.root.dataset.subscriptionState = 'one-time-only';
      return;
    }

    const setRechargeReady = (ready) => {
      const variantSupportsSubscription = Boolean(this.variant?.available && this.variant?.sellingPlans?.length);
      const useRecharge = ready && variantSupportsSubscription;
      this.rechargeHost.classList.toggle('is-recharge-ready', useRecharge);
      this.rechargeHost.setAttribute('aria-hidden', String(!useRecharge));
      if (this.purchaseFallback) this.purchaseFallback.hidden = useRecharge;
      this.root.dataset.subscriptionState = useRecharge
        ? 'recharge-ready'
        : (variantSupportsSubscription ? 'native-ready' : 'one-time-only');
      if (!variantSupportsSubscription || (useRecharge && this.selectedPlanId())) {
        const oneTimeFallback = this.root.querySelector('[name="ath-purchase-plan"][value=""]');
        if (oneTimeFallback) oneTimeFallback.checked = true;
        this.planLabels.forEach((item) => item.classList.toggle('is-selected', item.dataset.planCard === 'once'));
        const rechargeOneTime = this.rechargeHost.querySelector('.onetime-radio input[type="radio"], input[type="radio"][value="onetime"]');
        if (rechargeOneTime && !rechargeOneTime.checked) rechargeOneTime.click();
        this.rechargeHost.classList.remove('is-subscription-selected');
      }
      this.updatePrice();
    };

    this.prepareRechargeWidget = () => {
      const widget = this.rechargeHost.querySelector('.rc-widget');
      if (!widget) {
        setRechargeReady(false);
        this.rechargeHost.classList.remove('is-subscription-selected');
        return false;
      }
      const oneTime = widget.querySelector('.onetime-radio input[type="radio"], input[type="radio"][value="onetime"]');
      if (!oneTime) {
        setRechargeReady(false);
        this.rechargeHost.classList.remove('is-subscription-selected');
        return false;
      }

      const wrapper = widget.closest('.ath-pdp__app-blocks');
      this.normalizeRechargeCadenceCopy(widget);
      setRechargeReady(true);
      const syncSelection = () => {
        const scrollY = this.planInteractionScrollY;
        const subscription = widget.querySelector('.subscription-radio input[type="radio"], input[type="radio"][value="subscription"]');
        const subscriptionCard = widget.querySelector('.subscription-radio');
        const selected = Boolean(subscription?.checked || subscriptionCard?.classList.contains('rc-radio--active'));
        wrapper?.classList.toggle('is-subscription-selected', selected);
        if (Number.isFinite(scrollY)) {
          this.planInteractionScrollY = null;
          this.restoreVariantViewport(scrollY);
        }
      };

      if (widget.dataset.athDefaultApplied !== 'true') {
        const hasDeepLinkedPlan = new URL(window.location.href).searchParams.has('selling_plan');
        if (!oneTime.checked && !hasDeepLinkedPlan) oneTime.click();
        widget.dataset.athDefaultApplied = 'true';
      }
      if (widget.dataset.athSelectionBound !== 'true') {
        widget.dataset.athSelectionBound = 'true';
        const preserveViewport = () => {
          this.planInteractionScrollY = window.scrollY;
        };
        widget.addEventListener('pointerdown', preserveViewport, { passive: true });
        widget.addEventListener('keydown', preserveViewport);
        widget.addEventListener('change', () => window.requestAnimationFrame(syncSelection));
        widget.addEventListener('click', () => window.requestAnimationFrame(syncSelection));
      }
      window.requestAnimationFrame(syncSelection);
      return Boolean(this.variant?.available && this.variant?.sellingPlans?.length);
    };

    this.prepareRechargeWidget();
    this.rechargeObserver = new MutationObserver(() => {
      if (this.rechargeObserverFrame) return;
      this.rechargeObserverFrame = window.requestAnimationFrame(() => {
        this.rechargeObserverFrame = null;
        this.prepareRechargeWidget();
      });
    });
    this.rechargeObserver.observe(this.rechargeHost, { childList: true, subtree: true });
  }

  selectedOptions() {
    const values = [];
    this.root.querySelectorAll('[data-option-group]').forEach((group) => {
      values.push(group.querySelector('[data-option-input]:checked')?.value || '');
    });
    return values;
  }

  initMobileBuyBar() {
    if (!this.mobileBuyBar || !this.submit) return;
    this.mobileAddButton?.addEventListener('click', () => {
      if (!this.submit.disabled) this.submit.click();
    });

    const primaryBuyArea = this.root.querySelector('.ath-pdp__buy');
    if (!primaryBuyArea || !('IntersectionObserver' in window)) {
      this.mobileBuyBar.classList.add('is-visible');
      this.mobileBuyBar.setAttribute('aria-hidden', 'false');
      return;
    }

    this.mobileBuyObserver = new IntersectionObserver(([entry]) => {
      const shouldShow = !entry.isIntersecting;
      this.mobileBuyBar.classList.toggle('is-visible', shouldShow);
      this.mobileBuyBar.setAttribute('aria-hidden', String(!shouldShow));
    }, { threshold: 0.15, rootMargin: '0px 0px -72px 0px' });
    this.mobileBuyObserver.observe(primaryBuyArea);
  }

  selectedPlanId() {
    return this.root.querySelector('[name="ath-purchase-plan"]:checked')?.value || '';
  }

  updateVariant(changedInput = null) {
    const options = this.selectedOptions();
    this.variant = options.length
      ? this.data.variants.find((variant) => (
        variant.options.length === options.length
        && variant.options.every((option, index) => option === options[index])
      ))
      : this.data.variants.find((variant) => String(variant.id) === String(this.variantInput.value))
        || this.data.variants.find((variant) => variant.available)
        || this.data.variants[0];

    if (!this.variant && changedInput) {
      const groups = [...this.root.querySelectorAll('[data-option-group]')];
      const changedIndex = groups.indexOf(changedInput.closest('[data-option-group]'));
      this.variant = this.data.variants.find((variant) => (
        variant.available && variant.options[changedIndex] === changedInput.value
      )) || this.data.variants.find((variant) => variant.options[changedIndex] === changedInput.value);

      if (this.variant) {
        groups.forEach((group, index) => {
          const input = [...group.querySelectorAll('[data-option-input]')]
            .find((candidate) => candidate.value === this.variant.options[index]);
          if (input) input.checked = true;
        });
      }
    }

    if (!this.variant) {
      if (this.gallerySelection) this.gallerySelection.hidden = true;
      if (this.submit) this.submit.disabled = true;
      if (this.submit) this.submit.setAttribute('aria-disabled', 'true');
      if (this.submitLabel) this.submitLabel.textContent = 'Unavailable';
      if (this.mobileAddButton) {
        this.mobileAddButton.disabled = true;
        this.mobileAddButton.setAttribute('aria-disabled', 'true');
      }
      if (this.mobileAddLabel) this.mobileAddLabel.textContent = 'Unavailable';
      this.quantity?.classList.add('is-disabled');
      this.quantity?.setAttribute('aria-disabled', 'true');
      this.quantityControls.forEach((control) => { control.disabled = true; });
      if (this.status) {
        this.status.textContent = 'This combination is unavailable';
        this.status.classList.add('is-sold-out');
      }
      if (this.firstFoldStatus) {
        this.firstFoldStatus.hidden = false;
        this.firstFoldStatus.textContent = 'This combination is unavailable';
        this.firstFoldStatus.classList.remove('is-available');
        this.firstFoldStatus.classList.add('is-sold-out');
      }
      this.afterpayPlacements.forEach((placement) => {
        placement.hidden = true;
        placement.setAttribute('aria-hidden', 'true');
      });
      this.updateOptionAvailability();
      return;
    }

    const previousVariantId = String(this.variantInput.value);
    this.variantInput.value = this.variant.id;
    if (previousVariantId !== String(this.variant.id)) {
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (this.sku) this.sku.textContent = this.variant.sku || this.data.productId;
    if (this.gallerySelection) {
      this.gallerySelection.textContent = this.variant.galleryCaption || '';
      this.gallerySelection.hidden = !this.variant.galleryCaption;
    }
    const available = this.variant.available;
    const hasAvailableAlternative = this.data.variants.some((variant) => variant.available);
    if (this.submit) {
      this.submit.disabled = !available;
      this.submit.setAttribute('aria-disabled', String(!available));
    }
    this.quantity?.classList.toggle('is-disabled', !available);
    this.quantity?.setAttribute('aria-disabled', String(!available));
    this.quantityControls.forEach((control) => { control.disabled = !available; });
    if (this.submitLabel) this.submitLabel.textContent = available ? 'Add to cart' : 'Sold out';
    if (this.mobileAddButton) {
      this.mobileAddButton.disabled = !available;
      this.mobileAddButton.setAttribute('aria-disabled', String(!available));
    }
    if (this.mobileAddLabel) this.mobileAddLabel.textContent = available ? 'Add to cart' : 'Sold out';
    if (this.status) {
      this.status.textContent = available
        ? 'In stock and ready to ship'
        : (hasAvailableAlternative ? 'This option is sold out — choose another option' : 'This product is currently out of stock');
      this.status.classList.toggle('is-sold-out', !available);
    }
    if (this.firstFoldStatus) {
      this.firstFoldStatus.hidden = available;
      this.firstFoldStatus.textContent = available
        ? ''
        : (hasAvailableAlternative ? 'This option is sold out — choose another option' : 'This product is currently out of stock');
      this.firstFoldStatus.classList.toggle('is-available', available);
      this.firstFoldStatus.classList.toggle('is-sold-out', !available);
    }
    const oncePlan = this.root.querySelector('[data-plan-card="once"]');
    const oncePlanInput = oncePlan?.querySelector('input');
    oncePlan?.classList.toggle('is-unavailable', !available);
    oncePlan?.setAttribute('aria-disabled', String(!available));
    if (oncePlanInput) oncePlanInput.disabled = !available;
    this.updateOptionAvailability();
    this.updatePlanAvailability();
    this.prepareRechargeWidget?.();
    this.updatePrice();

    if (this.variant.featuredMediaId) this.showMedia(this.variant.featuredMediaId);

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('variant', this.variant.id);
    window.history.replaceState({}, '', nextUrl);
    this.root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: this.variant } }));
  }

  updateOptionAvailability() {
    const groups = [...this.root.querySelectorAll('[data-option-group]')];
    if (!groups.length) return;
    const selected = groups.map((group) => group.querySelector('[data-option-input]:checked')?.value || '');

    groups.forEach((group, optionIndex) => {
      group.querySelectorAll('[data-option-input]').forEach((input) => {
        const matching = this.data.variants.filter((variant) => variant.options.every((value, index) => (
          index === optionIndex
            ? value === input.value
            : (index < optionIndex ? (!selected[index] || value === selected[index]) : true)
        )));
        const exists = matching.length > 0;
        const available = matching.some((variant) => variant.available);
        const label = input.nextElementSibling;
        const disabled = !exists || !available;
        input.disabled = disabled;
        input.setAttribute('aria-disabled', String(disabled));
        input.setAttribute('aria-label', `${input.value}${!exists ? ', unavailable' : (!available ? ', sold out' : '')}`);
        label?.classList.toggle('is-unavailable', !exists);
        label?.classList.toggle('is-sold-out', exists && !available);
      });
    });
  }

  updatePlanAvailability() {
    const subscription = this.root.querySelector('[data-subscription-plan]');
    if (!subscription) return;
    const allocation = this.variant.available ? this.variant.sellingPlans?.[0] : null;
    subscription.hidden = !allocation;
    subscription.querySelector('input').value = allocation?.id || '';
    const subscriptionPrice = subscription.querySelector('[data-subscription-price]');
    if (subscriptionPrice && allocation) subscriptionPrice.textContent = this.formatMoney(allocation.price);
    if (this.subscriptionLabel && allocation) {
      const discount = this.variant.price > allocation.price
        ? Math.round(((this.variant.price - allocation.price) / this.variant.price) * 100)
        : 0;
      this.subscriptionLabel.textContent = `Subscribe & Save${discount > 0 ? ` ${discount}%` : ''}`;
      this.subscriptionSavingsCopies.forEach((item) => {
        item.textContent = discount > 0
          ? `Save ${discount}% on repeat deliveries`
          : 'Savings applied to repeat deliveries';
      });
    }
    if (this.subscriptionDelivery && allocation) {
      this.subscriptionDelivery.textContent = this.formatDeliveryCadence(allocation.name);
    }

    if (!allocation && this.selectedPlanId()) {
      this.root.querySelector('[name="ath-purchase-plan"][value=""]').checked = true;
      this.planLabels.forEach((item) => item.classList.toggle('is-selected', item.dataset.planCard === 'once'));
    }
  }

  updatePrice() {
    if (!this.variant) return;
    const quantity = this.normalizedQuantity(this.quantityInput?.value || 1);
    const planId = this.variant.available ? this.selectedPlanId() : '';
    const allocation = planId ? this.variant.sellingPlans?.find((plan) => String(plan.id) === String(planId)) : null;
    const activePrice = allocation?.price ?? this.variant.price;
    const compareAtPrice = allocation?.compareAtPrice || this.variant.compareAtPrice;
    const activeTotal = activePrice * quantity;
    const compareAtTotal = compareAtPrice * quantity;
    const onceTotal = this.variant.price * quantity;
    const firstSubscription = this.variant.available ? this.variant.sellingPlans?.[0] : null;
    const rechargeReady = this.root.dataset.subscriptionState === 'recharge-ready';

    if (this.nativeSubscriptionDetails) this.nativeSubscriptionDetails.hidden = !allocation;

    if (this.sellingPlanInput) {
      this.sellingPlanInput.disabled = rechargeReady || !planId;
      this.sellingPlanInput.value = rechargeReady ? '' : planId;
    }
    this.form?.querySelectorAll('input[name="selling_plan"]:not([data-selling-plan-id])').forEach((input) => {
      input.disabled = !rechargeReady;
    });
    if (this.price) this.price.textContent = this.formatMoney(activeTotal);
    if (this.mobilePrice) this.mobilePrice.textContent = this.formatMoney(activeTotal);
    if (this.oncePrice) this.oncePrice.textContent = this.formatMoney(onceTotal);
    if (this.subscriptionPrice && firstSubscription) {
      this.subscriptionPrice.textContent = this.formatMoney(firstSubscription.price * quantity);
    }
    const rechargeOncePrice = this.rechargeHost?.querySelector('.onetime-radio .price-label');
    const rechargeSubscriptionPrice = this.rechargeHost?.querySelector('.subscription-radio .price-label');
    const rechargeOnceTotal = this.formatMoney(onceTotal);
    if (rechargeOncePrice && rechargeOncePrice.textContent !== rechargeOnceTotal) {
      rechargeOncePrice.textContent = rechargeOnceTotal;
    }
    if (rechargeSubscriptionPrice && firstSubscription) {
      const rechargeSubscriptionTotal = this.formatMoney(firstSubscription.price * quantity);
      if (rechargeSubscriptionPrice.textContent !== rechargeSubscriptionTotal) {
        rechargeSubscriptionPrice.textContent = rechargeSubscriptionTotal;
      }
    }
    if (this.comparePrice) {
      this.comparePrice.textContent = compareAtTotal > activeTotal ? this.formatMoney(compareAtTotal) : '';
      this.comparePrice.hidden = !(compareAtPrice > activePrice);
    }

    if (this.afterpay && this.afterpayAmount) {
      const eligible = activeTotal >= 100;
      this.afterpay.hidden = !eligible;
      this.afterpayAmount.textContent = this.formatMoney(Math.round(activeTotal / 4));
    }

    const afterpayValue = (activeTotal / 100).toFixed(2);
    this.afterpayPlacements.forEach((placement) => {
      const shouldHide = !this.variant.available || activePrice <= 0;
      placement.hidden = shouldHide;
      placement.setAttribute('aria-hidden', String(shouldHide));
      if (placement.getAttribute('data-amount') !== afterpayValue) {
        placement.setAttribute('data-amount', afterpayValue);
        placement.dataset.amount = afterpayValue;
      }
    });
  }

  showMedia(mediaId) {
    const slides = [...this.root.querySelectorAll('[data-media-slide]')];
    const target = slides.find((slide) => Number(slide.dataset.mediaId) === mediaId);
    if (!target) return;
    slides.forEach((slide) => slide.classList.toggle('is-active', slide === target));
    this.root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      const active = Number(thumb.dataset.mediaId) === mediaId;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
  }

  openLightbox(image, trigger) {
    if (!this.lightbox || !this.lightboxImage) return;
    this.previouslyFocused = trigger || document.activeElement;
    this.lightboxImage.src = image.currentSrc || image.src || image.getAttribute('src');
    this.lightboxImage.alt = image.alt || this.data.productTitle || 'Product image';
    this.lightbox.hidden = false;
    document.body.classList.add('ath-pdp-lightbox-open');
    document.addEventListener('keydown', this.handleLightboxKeydown);
    this.lightboxClose?.focus({ preventScroll: true });
  }

  closeLightbox() {
    if (!this.lightbox || this.lightbox.hidden) return;
    this.lightbox.hidden = true;
    document.body.classList.remove('ath-pdp-lightbox-open');
    document.removeEventListener('keydown', this.handleLightboxKeydown);
    this.previouslyFocused?.focus?.({ preventScroll: true });
  }

  destroy() {
    this.rechargeObserver?.disconnect();
    this.mobileBuyObserver?.disconnect();
    window.cancelAnimationFrame(this.rechargeObserverFrame);
    window.cancelAnimationFrame(this.variantViewportFrame);
    document.removeEventListener('keydown', this.handleLightboxKeydown);
  }

  handleLightboxKeydown(event) {
    if (event.key === 'Escape') {
      this.closeLightbox();
      return;
    }
    if (event.key !== 'Tab' || !this.lightbox || this.lightbox.hidden) return;

    const focusable = [...this.lightbox.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => element.getClientRects().length > 0);
    if (!focusable.length) {
      event.preventDefault();
      this.lightbox.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  formatMoney(cents) {
    const numericAmount = Number(cents || 0) / 100;
    if (this.data.currency && window.Intl) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: this.data.currency,
        }).format(numericAmount);
      } catch {
        // Fall through to the theme's money format.
      }
    }
    const amount = numericAmount.toFixed(2);
    return (this.data.moneyFormat || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(amount))))
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }
}

const initAtHomeProductSections = (scope = document) => {
  scope.querySelectorAll('[data-ath-pdp]:not([data-ath-initialized])').forEach((root) => {
    root.dataset.athInitialized = 'true';
    root.athomePdpController = new AtHomeProductSection(root);
  });
};

const initAftercareDisclosures = (scope = document) => {
  scope.querySelectorAll('.ath-aftercare details:not([data-ath-disclosure-initialized])').forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    details.dataset.athDisclosureInitialized = 'true';
    const syncExpanded = () => summary.setAttribute('aria-expanded', String(details.open));
    const toggle = (event) => {
      event.preventDefault();
      const shouldOpen = !details.open;
      details.open = shouldOpen;
      syncExpanded();
      window.requestAnimationFrame(() => {
        details.open = shouldOpen;
        syncExpanded();
      });
    };
    summary.addEventListener('click', toggle);
    summary.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') toggle(event);
    });
    details.addEventListener('toggle', syncExpanded);
    syncExpanded();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAtHomeProductSections();
    initAftercareDisclosures();
  });
} else {
  initAtHomeProductSections();
  initAftercareDisclosures();
}

document.addEventListener('shopify:section:load', (event) => {
  initAtHomeProductSections(event.target);
  initAftercareDisclosures(event.target);
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll?.('[data-ath-pdp]').forEach((root) => root.athomePdpController?.destroy());
});
})();
